module.exports = __webpack_public_path__ + "img/example-5.94466abc.png";